import { createPersistedState } from 'pinia-plugin-persistedstate';

export default {
	install(app, options){
		if(app.config.globalProperties.$pinia){
			app.config.globalProperties.$pinia.use(createPersistedState({
				storage: sessionStorage,
				key: id => `__store__${id}`
			}));

			app.config.globalProperties.$pinia.use(({store, options: storeOptions}) => {
				store.__initHookCalled = false;
				if(!store.__initHookCalled && storeOptions.onInit && typeof(storeOptions.onInit) == 'function'){
					storeOptions.onInit.call(store);
					store.__initHookCalled = true;
				}
			});
		}
	}
};